import { createFileRoute } from '@tanstack/react-router'
import { MotoristasPage } from '@/pages/motoristas/MotoristasPage'

export const Route = createFileRoute('/_auth/motoristas')({
  component: MotoristasPage,
})
